import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IVehicle } from "../../models/Vehicle";
import GenericCell from "../shared/Cells/GenericCell";
import Modal from "../../layouts/Modal";
import CODStatus from "../leads/LeadInformation/CODStatus";


export default function VehicleCollectedCODStatus({ leadId, vehicle, classes = "py-6" }: { leadId: string, vehicle: IVehicle | null, classes?: string }) {
  const { t } = useTranslation("vehicles");
  const [open, setOpen] = useState(false);

  if (!vehicle) return null;

  return (
    <>
      <Modal open={open} width={"max-w-2xl"} setOpen={setOpen} >
        <CODStatus leadId={leadId} showAddress />
      </Modal>

      <div
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`${classes} hover:bg-gray-200 hover:shadow hover:scale-110 cursor-pointer`}
      >
        {vehicle?.codRequired ? (
          <GenericCell text={vehicle?.codConfirmedOn ? t("COD Confirmed") : t("No COD")} colour={vehicle?.codConfirmedOn ? "green" : "yellow"} title={t("COD Status")} />
        ) : (
          <GenericCell text={t("COD Not Required")} colour={"purple"} title={t("COD Not Required")} />
        )}
      </div>
    </>
  )
}
